import { Stack, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import DashboardTable from "../../../components/Dashboard/DashboardTable";
import Template from "../../../components/Dashboard/Template";

const diplayRows = ["date_and_month", "client_detail"];

function RecentClients({ tableData, isLoading }) {
  const { t } = useTranslation(["dashboard", "common"]);
  return (
    <Template
      primaryHeading={t("allNewCustomers")}
      secondaryHeading={t("latest")}
    >
      {tableData?.length > 0 ? (
        <DashboardTable
          diplayRows={diplayRows}
          tableData={tableData}
        />
      ) : isLoading === false && tableData?.length === 0 ? (
        <Stack height={"100%"} alignItems={"center"} justifyContent={"center"}>
          <Typography variant="h5" fontWeight={600}>
            {t("noDataFound", { ns: "common" })}
          </Typography>
        </Stack>
      ) : null}
    </Template>
  );
}

export default RecentClients;
